// export type MediaAssetType = 'image'|'video'|'raw'|'document';
export var MediaAssetType = /*#__PURE__*/function (MediaAssetType) {
  MediaAssetType["image"] = "image";
  MediaAssetType["video"] = "video";
  MediaAssetType["document"] = "document";
  MediaAssetType["raw"] = "raw";
  return MediaAssetType;
}(MediaAssetType || {});
export function getAssetTypeGroupInfo(type) {
  if (!type) return {
    label: "Unbekannt",
    icon: "question"
  };
  type = supportedFileTypeToMediaAssetType(type);
  switch (type) {
    case MediaAssetType.image:
      return {
        label: "Image",
        icon: "image"
      };
    case MediaAssetType.video:
      return {
        label: "Video",
        icon: "film"
      };
    case MediaAssetType.document:
      return {
        label: "Document",
        icon: "file-pdf"
      };
    case MediaAssetType.raw:
      return {
        label: "Raw File Asset",
        icon: "file"
      };
    default:
      return {
        label: "Unbekannt",
        icon: "question"
      };
  }
}
export function supportedFileTypeToMediaAssetType(type) {
  if (Object.values(MediaAssetType).includes(type)) {
    return type;
  }
  switch (type) {
    case 'image':
      return MediaAssetType.image;
    case 'video':
      return MediaAssetType.video;
    case 'document':
      return MediaAssetType.document;
    case 'any':
      return MediaAssetType.raw;
  }
  throw new Error('Could not convert supportedFileTypeGroup "' + type + '" to MediaAssetType!');
}
export function getMediaAssetTypeOptionsList() {
  return Object.values(MediaAssetType).map(type => {
    return {
      value: type,
      label: getAssetTypeGroupInfo(type).label
    };
  });
}